module.exports = __webpack_public_path__ + "img/dark-mode-icon-dark.f1a15eee.svg";